import { IntlShape, defineMessages } from 'react-intl';
import { ColumnsType } from 'antd/lib/table';
import {
  CreateOperatorPayload,
  EmrApiProvidersType,
} from '../../../../modules/types';

export type EmrTableDataType = {
  apiProviderName: string | null;
  organizationId: string;
  integrationType: string;
};

export const getEmrTableData = (
  editableData: CreateOperatorPayload,
  emrApiProviders: EmrApiProvidersType[],
): EmrTableDataType[] => {
  if (!editableData?.emrMappings?.length) {
    return [];
  }
  return editableData?.emrMappings?.map(mapping => ({
    apiProviderName:
      emrApiProviders?.find(item => item.id === mapping.apiProviderId)?.name ??
      null,
    organizationId: mapping.organizationId,
    integrationType: 'Full',
  }));
};

export const getIntegratedEMRsColumns = (
  intl: IntlShape,
): ColumnsType<EmrTableDataType> => [
  {
    title: intl.formatMessage(messages.emr),
    dataIndex: 'apiProviderName',
    key: 'apiProviderId',
  },
  {
    title: intl.formatMessage(messages.organizationId),
    dataIndex: 'organizationId',
    key: 'organizationId',
    // @ts-ignore Custom logic
    editable: true,
  },
  {
    title: intl.formatMessage(messages.type),
    dataIndex: 'integrationType',
    key: 'integrationType',
  },
];

const messages = defineMessages({
  emr: {
    id: 'OperatorForm.utils.emr',
    defaultMessage: 'EMR',
  },
  organizationId: {
    id: 'OperatorForm.utils.organizationId',
    defaultMessage: 'Organization Id',
  },
  type: {
    id: 'OperatorForm.utils.type',
    defaultMessage: 'Type',
  },
});
